import { StyleSheet } from 'aphrodite';
import { AppTheme, AppStyles } from '../../../styles/AppTheme';

export const Styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    // marginTop: AppTheme.toolbarHeight,
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    maxWidth: AppTheme.viewPort,
  },
  tile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //maxWidth: 300,
    // minWidth: 200,

    minHeight: 80,
    boxShadow: 'none',
    backgroundColor: AppTheme.secondaryBg,
    '@media (max-width: 767px)': {
      minHeight: 60,
    }
  },
  smallTile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    //maxWidth: 300,
    minHeight: 60,
    boxShadow: 'none',
    backgroundColor: AppTheme.secondaryBg,
    '@media (max-width: 767px)': {
      minHeight: 40,
    }
  },
  title: {
    color: AppTheme.primaryColor,
    fontSize: 16,
    fontWeight: 'bold',
  },
  link: {
    textDecoration: 'none',
    color: 'black'
  },

  //DasboardOrgs Style
  img: {
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    maxWidth: '100%',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 50,
    marginBottom: 50,
    '@media(max-width: 767px)': {
      marginTop: 20,
      marginBottom: 20,
    }
  },
  imageContainer: {
    width: 400,
    height: 400,
    borderRadius: 16,
    marginRight: 34,
    justifyContent: 'space-between',
    '@media(min-width: 768px) and (max-width: 1024px)': {
      width: 300,
      height: 300
    },
    '@media(max-width: 767px)': {
      width: 160,
      height: 160,
      borderRadius: 12,
      margin: '0px 5px'
    }
  },
  buttonContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    flexWrap: 'wrap'
  },
  button: {
    margin: '0px 5.5px 10px',
    padding: '13px 20px'
  },
})



// WEBPACK FOOTER //
// ./src/screens/admin/dashboard/Styles.js